import { BaseModalV3 } from 'components/ui/BaseModal'
import React, { useState } from 'react'
import { Post } from 'redux/reducers/feed'
import { PostModalHeader } from './PostModalHeader'
import { PostModalBody } from './PostModalBody'
import { PostModalFooter } from './PostModalFooter'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'

interface IProps {
  post: Post
  isOpen: boolean
  onClose: () => void
  targetParentCommentId?: string | null
  targetCommentId?: string | null
}
export const PostOverviewModal = ({ post, isOpen, onClose, targetParentCommentId, targetCommentId }: IProps) => {
  const [isInputFocus, setIsInputFocus] = useState<boolean>(false)

  // Get the actual post from Redux store to get real-time updates
  const actualPost = useSelector((state: RootState) => {
    const foundPost = state.feed.posts.find((p) => p.post_id === post.post_id)
    return foundPost || post
  })

  const commentsCounter = useSelector((state: RootState) => state.comments.commentsCounter[post.post_id])

  return (
    <BaseModalV3
      isOpen={isOpen}
      onClose={onClose}
      header={<PostModalHeader post={actualPost} onClose={onClose} />}
      body={
        <PostModalBody
          post={actualPost}
          onInputFocusChange={setIsInputFocus}
          targetParentCommentId={targetParentCommentId}
          targetCommentId={targetCommentId}
        />
      }
      footer={<PostModalFooter post={actualPost} isInputFocus={isInputFocus} commentsCounter={commentsCounter ?? 0} />}
      bodyProps={{ style: { background: 'white', height: '70vh' } }}
    />
  )
}
